import { IPathToPageIdMap } from '@move-frontend/contentful-routes';
import {
	EXTERNAL_LINK_TYPE_ID,
	IExternalLinkEntry,
	IInternalLinkEntry,
} from '../contentful';
import { getNewsItemUrl } from '../features/newsroom/news-and-updates/domain/use-cases/getNewsItemUrl';
import { getBlogItemUrl } from '../features/blogs/domain/use-cases/getBlogItemUrl';
import { getJobDetailsUrl } from '../features/careers/domain/use-cases/getJobDetailsUrl';

export type MaybeLink = IInternalLinkEntry | IExternalLinkEntry | undefined;

export function getUrlForPageId(
	pageId: string,
	pathToPageIdMap: IPathToPageIdMap,
) {
	const matchedPage = Object.entries(pathToPageIdMap).find(
		([, id]) => id === pageId,
	);

	if (!matchedPage) return `/${pageId}`;

	const [path] = matchedPage;

	return path;
}

export function getUrlForLink(
	link: MaybeLink,
	pathToPageIdMap: IPathToPageIdMap,
) {
	if (!link) return undefined;

	if (link.contentType === EXTERNAL_LINK_TYPE_ID) {
		return link.fields.url;
	}

	return getUrlForInternalLink(link, pathToPageIdMap);
}

export function getUrlForInternalLink(
	link: IInternalLinkEntry,
	pathToPageIdMap: IPathToPageIdMap,
) {
	let url = '';

	const { linkedType, page, entry } = link.fields;

	if (page && linkedType === 'page') {
		url = getUrlForPageId(page.fields.id, pathToPageIdMap);
	} else if (entry && linkedType === 'entry') {
		const { contentType } = entry;
		const { slug } = entry.fields;

		switch (contentType) {
			case 'news-item':
				url = getNewsItemUrl(slug);
				break;

			case 'blog-item':
				url = getBlogItemUrl(slug);
				break;

			case 'job':
				url = getJobDetailsUrl(slug);
				break;

			default:
				throw new Error(
					`Error: Entry with contentType '${contentType}' is not supported for internal links`,
				);
		}
		return url;
	}

	if (link.fields.hash) {
		url += `#${link.fields.hash}`;
	}

	return url;
}
